"use client";

import { useMemo } from "react";
import { useFeatureFlagEnabled, useFeatureFlagPayload } from "posthog-js/react";
import {
  parseSystemStatus,
  SYSTEM_STATUS_FLAG,
  type SystemStatus,
} from "@/lib/systemStatus";

/**
 * Resolves the current system-status banner from PostHog, or `null` when there
 * is nothing to show.
 *
 * Returns `null` while flags are still loading (PostHog has no `bootstrap`, so
 * the flag reads `undefined` on first paint) — see `parseSystemStatus`.
 */
export function useSystemStatus(): SystemStatus | null {
  const enabled = useFeatureFlagEnabled(SYSTEM_STATUS_FLAG);
  const payload = useFeatureFlagPayload(SYSTEM_STATUS_FLAG);

  return useMemo(() => parseSystemStatus(enabled, payload), [enabled, payload]);
}
